export default "__VITE_ASSET__gktdPDWw__"